import { useEffect } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import BackToTop from './components/Functionals/BackToTop'
import './assets/stylesheets/ui-kit.min.scss'
import './assets/stylesheets/settings.scss'
import './assets/stylesheets/styles.scss'
import './assets/stylesheets/custom.scss'
import './assets/stylesheets/pages.scss'
import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'
import Home from './Pages/Home/Home'
import About from './Pages/Info/About'
import Contact from './Pages/Info/Contact'
import Daily from './Pages/Menus/Daily'
import Dinner from './Pages/Menus/Dinner'
import Brunch from './Pages/Menus/Brunch'
import Drinks from './Pages/Menus/Drinks'
import Specials from './Pages/Menus/Specials'
import Pairing from './Pages/Events/Pairing'
// import Thanksgiving from './Pages/Events/Thanksgiving'
import Events from './Pages/Events/EventList'
// import NYE from './Pages/Events/NewYears'
import Valentines from './Pages/Events/Valentines'
import DaddyDaughter from './Pages/Events/DaddyDaughter'
import { tteatLink, dashLink } from './components/Shared/Links'
// import togoPickup from './assets/images/takeout-pickup.png'
import togoEat from './assets/images/takeout-eatBeach.png'

export function DualLunchRedirect(){
  useEffect(() => {
    window.location.href = '/DualLunch.pdf'
  }, [])
  return null
}
export function DualDinnerRedirect(){
  useEffect(() => {
    window.location.href = '/DualDinner.pdf'
  }, [])
  return null
}
export function DualBrunchRedirect(){
  useEffect(() => {
    window.location.href = '/DualBrunch.pdf'
  }, [])
  return null
}

function App() {
  let routes = (
    <Routes>
      <Route exact={true} path="/" element={<Home />} />
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/happy-hour" element={<Specials />} />
      <Route path="/daily-menu" element={<Daily />} />
      <Route path="/dinner-menu" element={<Dinner />} />
      <Route path="/brunch-menu" element={<Brunch />} />
      <Route path="/drink-menu" element={<Drinks />} />
      <Route path="/wine-list" element={<Drinks />} />
      <Route path="/pairing" element={<Pairing />} />
      <Route path="/dualbrunch" element={<DualBrunchRedirect />} />
      <Route path="/duallunch" element={<DualLunchRedirect />} />
      <Route path="/dualdinner" element={<DualDinnerRedirect />} />
      <Route path="/thanksgiving" element={<Home />} />
      <Route path="/events" element={<Events />} />
      <Route path="/new-years-eve" element={<Home />} />
      <Route path="/valentines" element={<Valentines />} />
      <Route path="/daddy-daughter-date" element={<DaddyDaughter />} />
    </Routes>
  )
  const location = useLocation()
  const wrapClass = location.pathname === '/' ? 'homeWrap' : 'bodyWrap'
  return (
    <div id="vg-top" className="fullSec vgWrap">
      <div className={wrapClass}>
        <div className="appWrap">
          <Header />
          <main className="main-wrapper">
            {routes}
          </main>
          <Footer />
          <BackToTop />
        </div>
      </div>
      <div id="takeout" className="uk-flex-top takeout-modal" uk-modal="true">
        <div className="uk-modal-dialog uk-modal-body uk-margin-auto-vertical umdTakeout">
          <button className="uk-modal-close-default" type="button" uk-close="true"></button>
          <div className="dsInner">
            <p>Order Delivery</p>
            <div className="toItem tteat">
              <a href={tteatLink} target="_blank" rel="noopener noreferrer" className="toLogo">
                <img src={togoEat} alt="Time to Eat delivery logo and link" className="fw" />
              </a>
            </div>
            <div className="toItem dash dashText">
              <a href={dashLink} target="_blank" rel="noopener noreferrer" className="toLogo toText">
                DOORDASH
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default App